var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { registerDestructor } from "@ember/destroyable";
import { action } from "@ember/object";
import Component from "@glimmer/component";
let SetupPredictorTooltipComponent = (_class = class SetupPredictorTooltipComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "private", void 0);
    window.ShowTooltip = this.showPredictorTooltip;
    window.HideTooltip = this.hidePredictorTooltip;
    registerDestructor(this, () => {
      delete window.ShowTooltip;
      delete window.HideTooltip;
    });
  }
  setPredictorTooltip(obj, visibility) {
    const cur = obj.id.split("_")[1];
    const tip = document.getElementById("tooltip-content_" + cur);
    tip?.setAttribute("visibility", visibility);
  }
  showPredictorTooltip(obj) {
    this.setPredictorTooltip(obj, "visible");
  }
  hidePredictorTooltip(obj) {
    this.setPredictorTooltip(obj, "hidden");
  }
}, _applyDecoratedDescriptor(_class.prototype, "showPredictorTooltip", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showPredictorTooltip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hidePredictorTooltip", [action], Object.getOwnPropertyDescriptor(_class.prototype, "hidePredictorTooltip"), _class.prototype), _class);
export { SetupPredictorTooltipComponent as default };